
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import engvars from '../lang/en';
import ptvars from '../lang/pt';

Vue.use(VueI18n);

const messages = {
    'en': engvars,
    'pt': ptvars
};

const i18n = new VueI18n({
    locale: 'en',
    messages,
});

export default i18n;
